import {FormattedMessage, injectIntl} from "react-intl";
import CSSModules from "react-css-modules";
import styles from "./auth.scss";
import React from "react";
import PropTypes from "prop-types";
import RaisedButton from 'components/common/material/RaisedButton';
import {privacyPolicyLink, termsOfUseLink} from "./authWithOtp/staticComponents2";
import {PHONE_NUMBER} from "../constants/sunbit";

const otpTypeOptions = {
  sms: 'SMS',
  phone: 'PHONE_CALL',
};

@injectIntl
@CSSModules(styles, {allowMultiple: true})
export class OtpTypeForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedOption: undefined,
    };
  }

  static propTypes = {
    phone: PropTypes.string,
    firstName: PropTypes.string,
    onSubmit: PropTypes.func,
    isFail: PropTypes.bool,
  };

  otpTypeSelected(selectedOption) {
    this.setState(state => {
      return {
        ...state,
        selectedOption: selectedOption,
      };
    });
  }

  render() {
    const { intl: {formatMessage} } = this.props;

    return (
      <div styleName="otpPlsEnter" data-at="selectOtpType">
        <div styleName="title">
          <span>Hi {this.props.firstName}</span>
          <br/>
          <FormattedMessage id="otp.form.weWillSend"/>
          <br/>
          <span>{this.props.phone}</span>
        </div>
        {
          this.props.isFail &&
          <div data-at={'genericError'} styleName="noAccount">
            <FormattedMessage id="common.technicalError"/>
          </div>
        }
        <div styleName="chooseOption">
          <FormattedMessage id="otp.form.chooseOption"/>
        </div>
        <div styleName="radioButtons">
          <div styleName="radioField">
            <input type="radio" name="radio" id={'textMe'} data-at={'textMeRadio'} onClick={() => this.otpTypeSelected(otpTypeOptions.sms)}></input>
            <label htmlFor="textMe">Text me</label>
          </div>
          <div styleName="radioField">
            <input type="radio" name="radio" id={'callMe'} data-at={'callMeRadio'} onClick={() => this.otpTypeSelected(otpTypeOptions.phone)}></input>
            <label htmlFor="callMe">Call me</label>
          </div>
        </div>

        {this.state.selectedOption === otpTypeOptions.sms &&
          <div styleName={'otpTypeLegal'} data-at="textMeLegalText">
            <FormattedMessage id="otpType.textMe.legalText" values={{termsAndConditions: termsOfUseLink, privacyPolicy: privacyPolicyLink}}/>
          </div>}

        {this.state.selectedOption === otpTypeOptions.phone &&
          <div styleName={'otpTypeLegal'} data-at="callMeLegalText">
            <FormattedMessage id="otpType.callMe.legalText" values={{termsAndConditions: termsOfUseLink, privacyPolicy: privacyPolicyLink}}/>
          </div>}

        <div styleName={"rememberMeWithNotPhone"}>
          <div styleName={"notYourPhone"}>
            <span styleName={"notYourPhoneCllText"}>Not your phone number? Call us at <a href={`tel:${PHONE_NUMBER}`}>{PHONE_NUMBER}</a></span>
          </div>
        </div>

        <RaisedButton data-at="selectOtpTypeAgreeAndContinueButton"
                      onClick={() => this.props.onSubmit(this.state.selectedOption)}
                      disabled={!this.state.selectedOption}
                      fullWidth={true}
                      primary={true}
                      label={formatMessage({id: 'otpType.button.approveOtpType'})}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/auth/OtpTypeForm.js